<template>
    <div class="signInDetail">
      <div class="mobileHeader" style="padding-bottom: 0%;">
        <p>
          <span style="margin-right: 10%"
            >进仓单号：{{ list.deliveryOrdeNo }}</span
          >
        </p>
        <p>
          <span>参考单号：{{ list.orgCustomerNo }}</span>
        </p>
        <p class="signInDetail-content">
          <span style="margin-right: 10%">目的仓库：{{ list.destination }}</span
          ><span>客户：{{ list.customName }}</span>
        </p>
        <p class="signInDetail-content">
          <span style="margin-right: 10%"
            >签收箱数：{{ list.actualBoxCount }}</span
          ><span>已收箱数：{{ list.scanningBoxCount }}</span>
        </p>
      </div>

      <div class="conventionalBox-info">
        <p class="p-title"><span style="color: red">*</span>常规箱信息</p>

        <div
          class="signInDetail-btnBox"
          v-for="(item, index) in info1"
          :key="index"
        >
          <ul>
            <li>
              <span>长</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxLength"
                @input="inputLenChange('info1', index, 'boxLength', 2)"
                @change="inputNumChange('info1', index, 'boxLength', 2)"
                placeholder="输入长(cm)"
              />
              <span>宽</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxWidth"
                @input="inputLenChange('info1', index, 'boxWidth', 2)"
                @change="inputNumChange('info1', index, 'boxWidth', 2)"
                placeholder="输入宽(cm)"
              />
              <span>高</span>
              <input
                type="number"
                class="volume fl"
                v-model="item.boxHeight"
                @input="inputLenChange('info1', index, 'boxHeight', 2)"
                @change="inputNumChange('info1', index, 'boxHeight', 2)"
                placeholder="输入高(cm)"
              />
            </li>
            <li>
              <span>毛重</span>
              <input
                type="number"
                class="volume fl"
                style="max-width: 27% !important"
                v-model="item.boxWeight"
                @input="inputLenChange('info1', index, 'boxWeight', 2)"
                @change="inputNumChange('info1', index, 'boxWeight', 2)"
                placeholder="请输入毛重(kg)"
              />
              <div>
                <el-button
                  size="small"
                  type="primary"
                  @click="pickUpBoxs(index)"
                  style=""
                  >顺序取箱</el-button
                >
                <span class="delInfo" @click="del(index)">{{
                  info1.length === 1 ? "清空" : "删除"
                }}</span>
                <span class="addInfo" @click="add()">添加</span>
              </div>

              <div class="signInDetail-btnBox-btn">
                扫描数:{{ item.scanningData.length }}
              </div>
            </li>
          </ul>
          <div class="boxMark-info">
            <van-field
              @blur="(val) => inputBoxMark(val, index)"
              @keyup.13="(val) => inputBoxMark(val, index)"
              size="small"
              v-model="item.boxMark"
              placeholder="请扫码箱唛"
              right-icon="scan"
              @click-right-icon="() => scanSku(index)"
            />
          </div>
        </div>
      </div>

      <div>
        <p class="p-title">收货统计</p>
        <div class="receipt-statistics">
          <div @click="showScannedBoxDialog('scanned')">
            已扫箱数:{{ list.scanBoxNos && list.scanBoxNos.length }}
          </div>
          <div @click="showScannedBoxDialog('pre')">
            预报箱数:{{ list.boxNos && list.boxNos.length }}
          </div>
        </div>
      </div>

      <div>
        <p class="p-title">收货照片</p>
        <div class="photo">
          <div class="sign-photo-cpntent">
            <div class="sign-photo-box">
              <ul>
                <li
                  class="sign-photo-item"
                  v-for="(item, index) in skuImg"
                  :key="index"
                >
                  <span class="delete-icon" @click="deleteImg(index)">x</span>
                  <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                  <img
                    :src="item"
                    class="sign-photo-item-img"
                    alt=""
                    @click="previewImage(item)"
                  />
                </li>

                <li class="sign-photo-btn">
                  <div class="photo">
                    <input
                      class="img hidden receive"
                      @change="changeImg()"
                      type="file"
                      name="cover"
                      ref="inputer"
                      accept="image/*"
                      multiple
                    />
                    <p @click="chooseImage">
                      <i class="el-icon-camera"></i>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <van-checkbox
              v-model="isAbnormal"
              shape="square"
              style="float: right; margin-right: 10px"
              >收货异常</van-checkbox
            >
            <div v-if="isAbnormal">
              <div class="yichang">
                <p class="p-title">异常说明</p>
                <van-field
                  size="small"
                  v-model="abnormalRemark"
                  placeholder="异常说明"
                />
              </div>
              <p class="p-title">异常照片</p>
              <div class="sign-photo-box">
                <ul>
                  <li
                    class="sign-photo-item"
                    v-for="(item, index) in skuImgAbnor"
                    :key="index"
                  >
                    <span class="delete-icon" @click="deleteImgAbnor(index)"
                      >x</span
                    >
                    <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                    <img
                      :src="item"
                      class="sign-photo-item-img"
                      alt=""
                      @click="previewImage(item)"
                    />
                  </li>

                  <li class="sign-photo-btn">
                    <div class="photo">
                      <input
                        class="img hidden abnor"
                        @change="changeImgAbnor()"
                        type="file"
                        name="cover"
                        ref="inputer"
                        accept="image/*"
                        multiple
                      />
                      <p @click="chooseImageAbnor">
                        <i class="el-icon-camera"></i>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sign-photo-save">
              <button class="submit-btn" @click="submit">保存</button>
            </div>
          </div>
        </div>
      </div>
      <van-dialog
        confirmButtonText="确认"
        cancelButtonText="取消"
        :before-close="confirm"
        v-model="showDialog"
        title="请输入顺序取箱数量"
        show-cancel-button
      >
        <div class="dialog-content">
          <van-field maxlength="8" v-model="BoxNum" type="digit" />
        </div>
      </van-dialog>
      <van-dialog
        confirmButtonText="确认"
        cancelButtonText="取消"
        :before-close="confirmScannedBox"
        v-model="scannedBoxDialog"
        :title="scannedBoxDialogType === 'scanned' ? '已扫箱数' : '预报箱数'"
        show-cancel-button
      >
        <ul class="bale-sku">
          <template v-if="scannedBoxDialogType === 'scanned'">
            <li v-for="(item, index) in list.scanBoxNos" :key="index">
              <div>
                <div class="sign-list">
                  <p>
                    <span>{{ item }}</span>
                    <a
                      style="float: right; margin-right: 10px; color: blue"
                      @click="delBox(item)"
                      >删除</a
                    >
                  </p>
                </div>
              </div>
            </li>
          </template>
          <template v-else>
            <li v-for="(item, index) in list.boxNos" :key="index">
              <div>
                <div class="sign-list">
                  <p>
                    <span>{{ item }}</span>
                  </p>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </van-dialog>
    </div>
</template>

<script>
import {
  Icon,
  Badge,
  Field,
  Tab,
  Tabs,
  Toast,
  ImagePreview,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Row,
  Col,
} from "vant";
import util from "util/date";
import { getDeliveryNo, submitSignFor } from "@/api/mobile/jy-receiptGoods_api";
import { mixins } from "../mobileMixins";
import axios from "axios";
import { BaseApiUrl } from "@/api/axios_config";
import { GetPrinterByUser, AddUserPrinter } from "@/api/mobile/common_api";

export default {
  data() {
    return {
      list: {},
      itemArr: ["本次签收数量"],
      info1: [
        {
          scanningData: [],
        },
      ],
      skuImg: [],
      skuImgAbnor: [],
      showDialog: false,
      imgFiles: [],
      imgFilesAbnor: [],
      BoxNum: "",
      saveImgUrlArr: [],
      saveImgUrlArrAbnor: [],
      scannedBoxDialog: false,
      resource: false,
      isAbnormal: false,
      scannedBoxDialogType: "scanned",
      pickUpBoxsIndex: 0,
      abnormalRemark: "",
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [ImagePreview.name]: ImagePreview,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Dialog.Component.name]: Dialog.Component,
    [ActionSheet.name]: ActionSheet,
    [Row.name]: Row,
    [Col.name]: Col,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  methods: {
    showScannedBoxDialog(type) {
      this.scannedBoxDialogType = type;
      this.scannedBoxDialog = true;
    },
    scanSku(index) {
      if (!this.checkInfo(index)) {
        return;
      }
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.addBoxData([a.resultStr], index);
        },
      });
    },
    // 检测是否写完全部信息
    checkAllInfo() {
      const arr1 = ["boxLength", "boxWidth", "boxHeight", "boxWeight"];
      for (let i = 0; i < this.info1.length; i++) {
        const {
          singleBoxQty,
          boxCount,
          boxLength,
          boxWidth,
          boxHeight,
          boxWeight,
        } = this.info1[i];
        if (
          singleBoxQty ||
          boxCount ||
          boxLength ||
          boxWidth ||
          boxHeight ||
          boxWeight
        ) {
          for (const key in this.info1[i]) {
            if (arr1.includes(key)) {
              if (!this.info1[i][key] || this.info1[i][key] === "0.00") {
                Toast(`请输入整箱${this.itemName[key]}`);
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    pickUpBoxs(index) {
      if (!this.checkInfo(index)) {
        return;
      }
      this.pickUpBoxsIndex = index;
      this.showDialog = true;
    },
    addBoxData(boxArr, index) {
      this.info1[index].scanningData.push(...boxArr);
      this.list.scanBoxNos.push(...boxArr);
      Toast.success("已添加" + boxArr.length + "个箱子");
    },
    checkInfo(index) {
      if (
        !this.info1[index].boxLength ||
        !this.info1[index].boxWidth ||
        !this.info1[index].boxHeight ||
        !this.info1[index].boxWeight
      ) {
        Toast("请先输入长宽高毛重");
        return false;
      } else {
        return true;
      }
    },
    inputBoxMark(val, index) {
      if (!this.checkInfo(index)) {
        return;
      }
      this.checkInfo(index);
      let boxVal = val.currentTarget.value + "";
      if (this.list.scanBoxNos && this.list.scanBoxNos.includes(boxVal)) {
        Toast("此箱唛已扫过，请勿重复扫码");
        return;
      }
      if (!this.list.boxNos.includes(boxVal)) {
        Toast("此箱唛不存在，请重新扫码");
        return;
      }
      this.addBoxData([boxVal], index);
    },
    delBox(item) {
      let that = this;
      this.list.scanBoxNos.splice(this.list.scanBoxNos.indexOf(item), 1);
      this.info1.forEach((ele, index) => {
        if (ele.scanningData.includes(item)) {
          that.info1[index].scanningData.splice(
            ele.scanningData.indexOf(item),
            1
          );
        }
      });
      Toast.success("已删除" + item + "箱子");
    },
    deleteImg(i) {
      this.skuImg.splice(i, 1);
      this.saveImgUrlArr.splice(i, 1);
    },

    deleteImgAbnor(i) {
      this.skuImgAbnor.splice(i, 1);
      this.saveImgUrlArrAbnor.splice(i, 1);
    },

    changeImg() {
      console.info(88);
      const img = document.getElementsByClassName("receive")[0];
      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.handleFiles(imgList);

      this.submitImg();
    },

    changeImgAbnor() {
      console.info(99);
      const img = document.getElementsByClassName("abnor")[0];
      let imgList = [...img.files];

      this.imgFilesAbnor.push(...imgList);

      this.handleFilesAbnor(imgList);

      this.submitImgAbnor();
    },

    chooseImage() {
      document.getElementsByClassName("receive")[0].click();
    },
    chooseImageAbnor() {
      document.getElementsByClassName("abnor")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImg, that.skuImg.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    handleFilesAbnor(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImgAbnor, that.skuImgAbnor.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push(...res.data.response);
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    submitImgAbnor() {
      const that = this;

      let formDatas = new FormData();

      this.imgFilesAbnor.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArrAbnor.push(...res.data.response);
          this.imgFilesAbnor = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    inputNumChange(name, i, field, fix = 1) {
      function toF(n, fix) {
        return Number(n).toFixed(fix);
      }

      let s = this[name][i][field];

      let num = toF(s, fix);
      if (num < 0) {
        Toast("请输入正数");
        num = toF(0, fix);
      }

      this.$set(this[name][i], field, num);
    },
    inputLenChange(name, i, field, fix = 1) {
      let s = this[name][i][field];
      if (s.includes(".")) {
        const m = s.split(".")[0];
        if (m.length > 3) {
          this.$set(this[name][i], field, Number(`${m.slice(0, 3)}.${m[1]}`));
        }
      } else {
        if (s.length > 3) {
          this.$set(this[name][i], field, this[name][i][field].slice(0, 3));
        }
      }
    },
    confirmScannedBox(action, done) {
      done();
    },
    confirm(action, done) {
      if (action === "confirm") {
        if (!this.BoxNum) {
          Toast("请输入数量");
          done(false);
          return;
        } else {
          let num = Number(this.BoxNum);
          if (num < 1) {
            Toast("请输入大于0的数量");
            done(false);
            return;
          }
          let start = this.list.scanBoxNos.length;
          let end = start + num;
          let arr = this.list.boxNos.slice(start, end);
          this.addBoxData(arr, this.pickUpBoxsIndex);
          this.showDialog = false;
          this.BoxNum = "";
          done();
        }
      } else {
        this.showDialog = false;
        this.BoxNum = "";
        done();
      }
    },
    add() {
      this.info1.push({
        boxLength: "",
        boxWidth: "",
        boxHeight: "",
        boxWeight: "",
        scanningData: [],
      });
    },

    del(i) {
      const that = this;
      const len = that.info1.length;
      const msg = len === 1 ? "清空" : "删除";
      Dialog.confirm({
        title: msg,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        message: `确认进行${msg}操作吗？`,
      })
        .then(() => {
          that.info1[i].scanningData.forEach((item) => {
            that.list.scanBoxNos.splice(that.list.scanBoxNos.indexOf(item), 1);
          });
          if (len === 1) {
            that.info1.splice(i, 1);
            that.add();
            return;
          }
          that.info1.splice(i, 1);
        })
        .catch(() => {});
    },
    init() {
      this.getDeliveryNo();
    },
    getDeliveryNo() {
      const { deliveryOrdeNo } = this.$route.query;
      const data = {
        deliveryOrdeNo,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getDeliveryNo(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.estimatedDate = util.formatDate.format(
              new Date(response.estimatedDate),
              "yyyy-MM-dd"
            );
          } catch {}
          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    inputParseIntNumChange(field) {
      let num = Number(this.list[field]);
      if (num > 10000) {
        Toast("数值最大10000");
        num = 10000;
      } else if (num < 0) {
        Toast("请输入正整数");
        num = Math.abs(num);
      }
      this.$set(this.list, field, parseInt(num));
    },
    submit() {
      const that = this;
      const { tfSignForID, signForNumber } = this.list;
      if (!this.info1 || !this.info1.length) {
        return Toast("请扫码箱唛");
      }
      if (this.saveImgUrlArr.length === 0) {
        return Toast("请上传收货照片");
      }
      if (this.isAbnormal && this.saveImgUrlArrAbnor.length === 0) {
        return Toast("有异常请上传异常照片");
      }
      let receiptBoxList = this.info1.map((item) => {
        return {
          boxWeight: item.boxWeight,
          boxLength: item.boxLength,
          boxWidth: item.boxWidth,
          boxHeight: item.boxHeight,
          customerBoxs: item.scanningData,
        };
      });
      const data = {
        tfSignForID: tfSignForID,
        signForNumber: signForNumber,
        resource: this.resource,
        receiptBoxList: receiptBoxList,
        imageUrls: this.saveImgUrlArr,
        isAbnormal: that.isAbnormal,
        abnormalRemark: that.abnormalRemark,
        imageUrlsAbnor: this.saveImgUrlArrAbnor,
      };

      Toast.loading({
        message: "收货中...",
        forbidClick: true,
      });

      submitSignFor(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          Toast.success("收货成功");
          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "./style.less";
.submit-btn {
  margin-top: 10px;
}
.yichang {
  .van-cell {
    border: 1px solid #adadad;
    width: 93%;
    margin: 0 auto;
  }
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  margin-top: 2px;
  padding-left: 10px;
  font-size: 14px;
}
</style>
